"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Paste_1 = require("./Paste");
exports.Paste = Paste_1.default;
//# sourceMappingURL=index.js.map